/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Suggestions_UnplaceableInputs */



/**
* | output |
* | --- |
* | "{count} couldn't be placed" |
*
* @param {Suggestions_UnplaceableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_unplaceable = /** @type {((inputs: Suggestions_UnplaceableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_UnplaceableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} konnten nicht platziert werden`)
	return /** @type {LocalizedString} */ (`${i?.count} couldn't be placed`)
});